import React from "react";
import { SvgIcon } from "@material-ui/core";

const Coverage = props => (
  <SvgIcon viewBox="0 0 21.215 18.858" {...props}>
    <path
      id="Trazado_2235"
      data-name="Trazado 2235"
      d="M20.562,12.354a2,2,0,0,0-2.574-.044l-2.269,1.816a.393.393,0,0,1-.247.085H13.94a2.05,2.05,0,0,0,.177-1.19,2.122,2.122,0,0,0-2.129-1.757H6.677a3.523,3.523,0,0,0-2.121.707L3.142,13.032H.295A.3.3,0,0,0,0,13.327v.589a.3.3,0,0,0,.295.295H3.536l1.727-1.3a2.365,2.365,0,0,1,1.414-.471h5.4a.884.884,0,0,1,0,1.768H8.839a.589.589,0,0,0,0,1.179h6.637a1.588,1.588,0,0,0,.983-.343l2.269-1.812a.817.817,0,0,1,1.046,0,.783.783,0,0,1-.033,1.2l-3.712,2.972a1.566,1.566,0,0,1-.983.343H.295A.3.3,0,0,0,0,18.044v.589a.3.3,0,0,0,.295.295h14.75a2.739,2.739,0,0,0,1.716-.6l3.716-2.972a1.966,1.966,0,0,0,.085-3ZM10.139,9.294a.642.642,0,0,0,.939,0l4.011-4.2A3.049,3.049,0,0,0,14.883.72,2.806,2.806,0,0,0,11.019,1l-.412.427L10.2,1A2.814,2.814,0,0,0,6.335.72a3.052,3.052,0,0,0-.206,4.372ZM7.086,1.611a1.666,1.666,0,0,1,2.28.21l1.241,1.3,1.241-1.3a1.676,1.676,0,0,1,2.28-.21,1.859,1.859,0,0,1,.125,2.655L10.607,8.089,6.961,4.267A1.865,1.865,0,0,1,7.086,1.611Z"
      transform="translate(0 -0.071)"
      fill="rgba(112,112,112,0.35)"
    />
  </SvgIcon>
);

export default Coverage;
